/**
 * Wertekonto-Typ – abgestimmt auf Backend WalletType.
 * Für Vergleiche verwenden statt Magic Numbers.
 */
export const WALLET_TYPE_POINTS = 1;
export const WALLET_TYPE_VALUE = 2;

/**
 * Buchungsgründe – abgestimmt auf Backend WalletTransactionReason.
 * Steuern die Herkunfts-Anzeige im Wertekonto-Verlauf.
 */
export const WALLET_REASON_MANUAL_ADJUSTMENT = 1;
export const WALLET_REASON_STORNO_CREDIT = 2;
export const WALLET_REASON_OFFSET_AGAINST_RECEIVABLE = 3;
export const WALLET_REASON_PAYMENT_TOP_UP = 4;
export const WALLET_REASON_USAGE = 5;
export const WALLET_REASON_IMPORT = 6;
export const WALLET_REASON_PROMOTION_BONUS = 7;
export const WALLET_REASON_REST_PERIOD_CREDIT = 8;
export const WALLET_REASON_PRICE_CORRECTION_CREDIT = 9;

/** i18n-Schlüssel je Buchungsgrund (Herkunft im Verlauf). */
export const WALLET_REASON_LABEL_KEYS: Record<number, string> = {
  [WALLET_REASON_MANUAL_ADJUSTMENT]: "wallet.reason.manualAdjustment",
  [WALLET_REASON_STORNO_CREDIT]: "wallet.reason.stornoCredit",
  [WALLET_REASON_OFFSET_AGAINST_RECEIVABLE]: "wallet.reason.offsetAgainstReceivable",
  [WALLET_REASON_PAYMENT_TOP_UP]: "wallet.reason.paymentTopUp",
  [WALLET_REASON_USAGE]: "wallet.reason.usage",
  [WALLET_REASON_IMPORT]: "wallet.reason.import",
  [WALLET_REASON_PROMOTION_BONUS]: "wallet.reason.promotionBonus",
  [WALLET_REASON_REST_PERIOD_CREDIT]: "wallet.reason.restPeriodCredit",
  [WALLET_REASON_PRICE_CORRECTION_CREDIT]: "wallet.reason.priceCorrectionCredit"
};
